module.exports = __webpack_public_path__ + "fonts/PPRightGrotesk-CompactBlack.bedeae1.woff";